/**
 * Created by mestrad on 2018. 06. 27..
 */

var Style = {
    showClass: "nnpAnimateIn",
    hideClass: "nnpAnimateOut",
    hiddenClass: "nnpHidden",
    show: function ($item) {
        $item
            .addClass(this.showClass)
            .removeClass(this.hideClass)
            .removeClass(this.hiddenClass);
        $item.closest('.wrapper').removeClass(this.hiddenClass);
    },
    hide: function ($item) {
        $item
            .removeClass(this.showClass)
            .addClass(this.hideClass);
        $item.closest('.wrapper').addClass(this.hiddenClass);
    }
}

export default Style;